export function RemoteCrashed() {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="text-center max-w-md">
        <div className="text-destructive text-lg font-semibold mb-2">
          Application Crashed
        </div>
        <p className="text-sm text-muted-foreground mb-4">
          This remote application failed at runtime. Please reload and try again.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="px-4 py-2 text-sm font-medium bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
        >
          Reload
        </button>
      </div>
    </div>
  );
}
